import { Infer, boolean, object } from "superstruct";

export const NudgesSettingsResponseSchema = object({
    isAllowed: boolean(),
});

export type NudgesSettingsResponseType = Infer<
    typeof NudgesSettingsResponseSchema
>;
